import { BinanceFutuAPICallReal } from "@/entities/binance/api/binanceBeAuth"


// 레버리지 버켓 조회
export const FUTU_GetLeverageBracket = async (): Promise<FutuAPI_GetLeverageBracket_Res[]> => {
  const result = await BinanceFutuAPICallReal('GET', '/fapi/v1/leverageBracket', '')
  // console.log("FUTU_GetLeverageBracket", result)
  return result
}

// 사용자 발란스 조회
export const FUTU_GetBalance = async (): Promise<FutuAPI_GetBalance_Res[]> => {
  const result = await BinanceFutuAPICallReal('GET', '/fapi/v2/balance', '')
  return result
}

//  사용자 발란스 조회 USDT
export const FUTU_GetBalanceUSDT = async (): Promise<FutuAPI_GetBalance_Res> => {
  const result = await BinanceFutuAPICallReal('GET', '/fapi/v2/balance', '')
  for (let i = 0; i < result.length; i++) {
    if (result[i].asset === 'USDT') {
      return result[i]
    }
  }
  return result
}

export const FUTU_GetPositionList = async (symbol?: string): Promise<FutuAPI_GetPositionList_Res[]> => {
  let bodydata = ''
  if (symbol) {
    bodydata = 'symbol=' + symbol
  }
  const result = await BinanceFutuAPICallReal('GET', '/fapi/v2/positionRisk', bodydata)
  return result
}

export const FUTU_ChangeLeverage = async ({ symbol, leverage }: FutuAPI_ChangeLeverage_Req): Promise<FutuAPI_ChangeLeverage_Res> => {
  const bodydata = 'symbol=' + symbol.toUpperCase() + '&leverage=' + String(leverage)
  const result = await BinanceFutuAPICallReal('POST', '/fapi/v1/leverage', bodydata)
  return result
}

export const FUTU_ChangeMarginType = async ({ symbol, marginType }: FutuAPI_ChangeMarginType_Req): Promise<ErrorMessage> => {
  const bodydata = 'symbol=' + symbol.toUpperCase() + '&marginType=' + marginType
  const result = await BinanceFutuAPICallReal('POST', '/fapi/v1/marginType', bodydata)
  return result
}

export const FUTU_GetUserOpenOrders = async (): Promise<FutuAPI_GetusesrOpenOrders_Res[]> => {
  const result = await BinanceFutuAPICallReal('GET', '/fapi/v1/openOrders', '')
  return result
}

// 신규 Algo 미체결 조회
export const FUTU_GetUserOpenAlgoOrders = async (): Promise<FutuAPI_GetUserOpenAlgoOrders_Res[]> => {
  const result = await BinanceFutuAPICallReal('GET', '/fapi/v1/openAlgoOrders', '')
  return result
}

// 유저 웹소켓 리슨키 요청
export const FUTU_listenKey = async (): Promise<FutuAPI_listenKey_Res> => {
  const result = await BinanceFutuAPICallReal('POST', '/fapi/v1/listenKey', '')
  return result
}

